const AUTH_LAST_ERROR_KEY = "admin_auth_last_error";

export function persistAuthError(message, extra = {}) {
  if (!message || typeof message !== "string") return;
  try {
    sessionStorage.setItem(
      AUTH_LAST_ERROR_KEY,
      JSON.stringify({ message, at: Date.now(), ...extra })
    );
  } catch {
    // ignore quota / private mode
  }
}

export function getPersistedAuthErrorRecord() {
  try {
    const raw = sessionStorage.getItem(AUTH_LAST_ERROR_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readPersistedAuthError(maxAgeMs = 30 * 60 * 1000) {
  const record = getPersistedAuthErrorRecord();
  if (!record?.message) return null;
  if (maxAgeMs > 0 && record.at && Date.now() - record.at > maxAgeMs) {
    clearPersistedAuthError();
    return null;
  }
  return record.message;
}

export function clearPersistedAuthError() {
  try {
    sessionStorage.removeItem(AUTH_LAST_ERROR_KEY);
  } catch {
    // ignore
  }
}

export function getAuthErrorFromSearchParams(searchParams) {
  if (!searchParams) return null;
  const description = searchParams.get("error_description");
  const error = searchParams.get("error");
  if (description) {
    try {
      return decodeURIComponent(description.replace(/\+/g, " "));
    } catch {
      return description;
    }
  }
  if (error) return error;
  return null;
}

/** Read Auth0 callback errors from query string or hash (runs before React). */
export function getAuthErrorFromWindowLocation() {
  const fromQuery = getAuthErrorFromSearchParams(
    new URLSearchParams(window.location.search)
  );
  if (fromQuery) return fromQuery;

  const hash = window.location.hash?.replace(/^#/, "");
  if (!hash) return null;
  return getAuthErrorFromSearchParams(new URLSearchParams(hash));
}

/** Call once at app bootstrap so errors survive before React mounts. */
export function captureInitialAuthErrorFromUrl() {
  const message = getAuthErrorFromWindowLocation();
  if (!message) return null;
  persistAuthError(message, { source: "url_bootstrap" });
  return message;
}
